import { render, staticRenderFns } from "./OutdoorProduct.vue?vue&type=template&id=63b5288b&scoped=true&"
import script from "./OutdoorProduct.vue?vue&type=script&lang=js&"
export * from "./OutdoorProduct.vue?vue&type=script&lang=js&"
import style0 from "./OutdoorProduct.vue?vue&type=style&index=0&id=63b5288b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b5288b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VProgressCircular,VRow})
